import PropTypes from "prop-types";
import { useEffect, useState } from "react";

// MUI
import { Skeleton, Stack } from "@mui/material";

export default function SingleTiersLoader(props) {
	const [tiers, setTiers] = useState(2);
	const [buttonsAmount, setButtonsAmount] = useState(2);

	useEffect(() => {
		if (props.tiers) {
			setTiers(props.tiers);
		}

		if (props.buttonsAmount) {
			setButtonsAmount(props.buttonsAmount);
		}
		return () => {
			setTiers(2);
			setButtonsAmount(2);
		};
	}, [props]);

	return (
		<Stack direction={"row"} spacing={1} mt={2} sx={props.sx || { padding: "0 32px" }}>
			<Stack spacing={1}>
				<Skeleton variant="rectangular" width={360} height={25} sx={{ borderRadius: "6px" }} />
				{Array.from(Array(tiers)).map((_, key) => (
					<Stack key={`single-tiers-items-loader-${key}`} direction={"row"} spacing={2} width={360}>
						<Skeleton variant="rectangular" width={95} height={25} sx={{ borderRadius: "6px" }} />
						<Skeleton variant="rectangular" width={95} height={25} sx={{ borderRadius: "6px" }} />
						<Skeleton variant="rectangular" width={140} height={25} sx={{ borderRadius: "6px" }} />
					</Stack>
				))}

				{props.buttons && (
					<Stack direction={"row"} justifyContent={"center"} spacing={1} mt={"24px !important"} width={380}>
						{Array.from(Array(buttonsAmount)).map((_, key) => (
							<Skeleton
								key={`single-tiers-buttons-loader-${key}`}
								variant="rectangular"
								width={120}
								height={28}
								sx={{ borderRadius: "6px" }}
							/>
						))}
					</Stack>
				)}
			</Stack>
			{props.selector && <Skeleton variant="rectangular" width={101} height={70} sx={{ borderRadius: "10px" }} />}
		</Stack>
	);
}
SingleTiersLoader.propTypes = {
	tiers: PropTypes.number,
	buttonsAmount: PropTypes.number,
	sx: PropTypes.object,
	buttons: PropTypes.bool,
	selector: PropTypes.bool,
};
